import { http } from "./http";
import type { FanCashoutResult, FanReferralStats, IgDmVerifyStart, IgDmVerifyStatus, MyRank, SavedTalentList } from "../types/fans";

// The signed-in fan's standing. Sign-in, profile and orders live in src/lib/fanAccount.ts.
export const fansApi = {
  myRank: () => http.get<MyRank>("/fans/me/rank"),
  /** "Verify with a DM" — a one-time ig.me link. 503 { msg: "not_available" } while the feature is off. */
  startInstagramDmVerify: () => http.post<IgDmVerifyStart>("/fans/me/instagram/dm-verify"),
  /** pending | verified | taken | expired — polled while the fan is in Instagram. */
  instagramDmVerifyStatus: (sessionId: string) =>
    http.get<IgDmVerifyStatus>(`/fans/me/instagram/dm-verify/${encodeURIComponent(sessionId)}`),
  /** Fan Refer & Earn: the code (given on the first ask), who joined, points earned. */
  referrals: () => http.get<FanReferralStats>("/fans/me/referrals"),
  setReferralCode: (code: string) => http.patch<{ code: string }>("/fans/me/referral-code", { code }),
  /** Fan cash-out (part 2): MassPay payee + the ID check link, once → { url } | { done: true }. */
  cashoutConnect: (body: { legalFirstName: string; legalLastName: string; countryCode: string }) =>
    http.post<{ url?: string; done?: boolean; reused?: boolean }>("/fans/me/cashout/connect", body),
  /** Re-read from MassPay until the ID check has passed. */
  cashoutStatus: () => http.get<{ kycStatus: string; onHold: boolean }>("/fans/me/cashout/status"),
  /** Send what's ready to the fan's MassPay wallet. The same key twice is the same cash-out. */
  cashout: (requestKey: string) => http.post<FanCashoutResult>("/fans/me/cashout", { requestKey }),
  /** Saved talent (1.5.3, lib/savedTalent): every answer is the whole list. A server without it answers 404. */
  savedTalent: () => http.get<SavedTalentList>("/fans/me/saved"),
  saveTalent: (slug: string) => http.put<SavedTalentList>(`/fans/me/saved/${encodeURIComponent(slug)}`),
  unsaveTalent: (slug: string) => http.delete<SavedTalentList>(`/fans/me/saved/${encodeURIComponent(slug)}`),
  /** Sign-in: the device's list (newest first) joins the account's. */
  mergeSavedTalent: (slugs: string[]) => http.post<SavedTalentList>("/fans/me/saved/merge", { slugs }),
};
